export default "__VITE_ASSET__CbkjCtcG__"